import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/authService';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-privacy-questions',
  standalone: false,

  templateUrl: './privacy-questions.component.html',
  styleUrl: './privacy-questions.component.scss'
})
export class PrivacyQuestionsComponent {
  renderer: Renderer2;
  contactForm = new FormGroup({
    privacyQuestionsOptionsSet: new FormControl("", [
      Validators.required,
      Validators.min(1),
      Validators.max(7),
    ]),
  });

  constructor(private authService: AuthService, private http: HttpClient, public el: ElementRef, renderer: Renderer2, public router: Router) {
      this.renderer = renderer;
    }

  public handlePrivacyQuestionOptionsSetChange(): void {
    const privacyQuestionOptionOneResponse = this.el.nativeElement.querySelector('#privacyQuestionOptionOneResponse');
    const privacyQuestionOptionTwoResponse = this.el.nativeElement.querySelector('#privacyQuestionOptionTwoResponse');
    const privacyQuestionOptionThreeResponse = this.el.nativeElement.querySelector('#privacyQuestionOptionThreeResponse');
    const privacyQuestionOptionFourResponse = this.el.nativeElement.querySelector('#privacyQuestionOptionFourResponse');
    const privacyQuestionOptionFiveResponse = this.el.nativeElement.querySelector('#privacyQuestionOptionFiveResponse');
    const privacyQuestionOptionSixResponse = this.el.nativeElement.querySelector('#privacyQuestionOptionSixResponse');
    const privacyQuestionOptionSevenResponse = this.el.nativeElement.querySelector('#privacyQuestionOptionSevenResponse');
    const privacyQuestionOptions = [privacyQuestionOptionOneResponse, privacyQuestionOptionTwoResponse, privacyQuestionOptionThreeResponse, privacyQuestionOptionFourResponse, privacyQuestionOptionFiveResponse, privacyQuestionOptionSixResponse, privacyQuestionOptionSevenResponse];

    switch (this.contactForm.controls.privacyQuestionsOptionsSet.value) {
      case '1':
        if (privacyQuestionOptionOneResponse && !privacyQuestionOptionOneResponse.classList.contains('d-none')) {
          this.renderer.removeClass(privacyQuestionOptionOneResponse, 'd-none');
        }
        this.hideOptions(privacyQuestionOptions, privacyQuestionOptionOneResponse);
        break;
      case '2':
        if (privacyQuestionOptionTwoResponse && !privacyQuestionOptionTwoResponse.classList.contains('d-none')) {
          this.renderer.removeClass(privacyQuestionOptionTwoResponse, 'd-none');
        }
        this.hideOptions(privacyQuestionOptions, privacyQuestionOptionTwoResponse);
        break;
      case '3':
        if (privacyQuestionOptionThreeResponse && !privacyQuestionOptionThreeResponse.classList.contains('d-none')) {
          this.renderer.removeClass(privacyQuestionOptionThreeResponse, 'd-none');
        }
        this.hideOptions(privacyQuestionOptions, privacyQuestionOptionThreeResponse);
        break;
      case '4':
        if (privacyQuestionOptionFourResponse && !privacyQuestionOptionFourResponse.classList.contains('d-none')) {
          this.renderer.removeClass(privacyQuestionOptionFourResponse, 'd-none');
        }
        this.hideOptions(privacyQuestionOptions, privacyQuestionOptionFourResponse);
        break;
      case '5':
        if (privacyQuestionOptionFiveResponse && !privacyQuestionOptionFiveResponse.classList.contains('d-none')) {
          this.renderer.removeClass(privacyQuestionOptionFiveResponse, 'd-none');
        }
        this.hideOptions(privacyQuestionOptions, privacyQuestionOptionFiveResponse);
        break;
      case '6':
        if (privacyQuestionOptionSixResponse && !privacyQuestionOptionSixResponse.classList.contains('d-none')) {
          this.renderer.removeClass(privacyQuestionOptionSixResponse, 'd-none');
        }
        this.hideOptions(privacyQuestionOptions, privacyQuestionOptionSixResponse);
        break;
      case '7':
        if (privacyQuestionOptionSevenResponse && !privacyQuestionOptionSevenResponse.classList.contains('d-none')) {
          this.renderer.removeClass(privacyQuestionOptionSevenResponse, 'd-none');
        }
        this.hideOptions(privacyQuestionOptions, privacyQuestionOptionSevenResponse);
        break;
      default:
        this.hideOptions(privacyQuestionOptions);
        break;
    }
  }

  /**
   * Hides the specified HTML elements by adding the 'd-none' class to them,
   * except for the optional element that should not be hidden.
   * @param elements - An array of HTML elements to hide.
   * @param elementToNotHide - An optional HTML element that should not be hidden.
   * @returns void
   */
  private hideOptions(elements: HTMLElement[], elementToNotHide?: HTMLElement): void {
    elements.forEach(element => {
      if (element && !element.classList.contains('d-none')) {
        this.renderer.addClass(element, 'd-none');
      }
    });
    if (elementToNotHide && elementToNotHide.classList.contains('d-none')) {
      this.renderer.removeClass(elementToNotHide, 'd-none');
    }
  }
}
